module.exports = __webpack_public_path__ + "img/GAME_BLOCKFLIP2.7d85bb7f.jpg";